import API from './api';
export const authenticate = async (credentials) => {
    return API.post('/auth/login', credentials).then(res => res.data);
}

export const changePassword = async (credentials) => {
  return API.post('/auth/change-password', credentials).then(res => res.data);
}

export const refresh = async (credentials) => {
  return API.post('/auth/refresh', credentials, {withCredentials: true,}).then(res => res.data);
}